import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialChat } from '../initialState'

const chatSlice = createSlice({
  name: 'chat',
  initialState: initialChat,
  reducers: {
    setUnconsumedMessagesCount: (state, action: PayloadAction<any>) => {
      state.unconsumedMessagesCount = action.payload
    },
    setOpenChat: (state, action: PayloadAction<boolean>) => {
      state.isOpenChat = action.payload
    },
  },
})
export const chatAction = chatSlice.actions
export default chatSlice
